import { showMessage } from "../store/message/actions";
import { store } from "../store/rootReducer";

export const showSuccess = (message) => {
  store.dispatch(showMessage(message, "success"));
};
